// extracted by mini-css-extract-plugin
module.exports = {"label":"Radio_label__2hYVE","input":"Radio_input__1L1ng","radio":"Radio_radio__pf-XP"};